import api from "../api/axios";

const API_URL = ``;

export const getHierarchy = async (companyId) => {
  try {
    const response = await api.get(
      `${API_URL}api/organization-hierarchy/${companyId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching hierarchy:", error);
    return [];
  }
};
